import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Field from "../Field";

interface TeamForm {
  name: string;
  city: string;
  information: string;
}

interface CreateTeamDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teamForm: TeamForm;
  setTeamForm: React.Dispatch<React.SetStateAction<TeamForm>>;
  loading: boolean;
  onCreate: () => void;
}

const CreateTeamDialog: React.FC<CreateTeamDialogProps> = ({
  open,
  onOpenChange,
  teamForm,
  setTeamForm,
  loading,
  onCreate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Yeni komanda yarat</DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        <Field label="Komanda adı">
          <Input
            placeholder="Məs: Berserk"
            value={teamForm.name}
            onChange={(e) => setTeamForm((f) => ({ ...f, name: e.target.value }))}
          />
        </Field>
        <Field label="Şəhər">
          <Input
            placeholder="Məs: Bakı"
            value={teamForm.city}
            onChange={(e) => setTeamForm((f) => ({ ...f, city: e.target.value }))}
          />
        </Field>
        <Field label="Məlumat">
          <textarea
            placeholder="Komanda haqqında qısa məlumat"
            value={teamForm.information}
            onChange={(e) => setTeamForm((f) => ({ ...f, information: e.target.value }))}
            className="w-full min-h-[80px] rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/40 transition-all"
          />
        </Field>
        <Button onClick={onCreate} disabled={loading} className="w-full">
          Yarat
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default CreateTeamDialog;
